import { lighten } from '@mui/material/styles';
import { makeStyles } from '../../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiDateRangePickerViewDesktop-container': {
            borderRight: 'none',
        },
        '& .MuiPickersArrowSwitcher-root .MuiTypography-subtitle1': {
            color: theme.colors.gray[800],
        },
        '& .MuiDateRangePickerDay-rangeIntervalDayHighlight': {
            backgroundColor: lighten(theme.colors.primary.main, 0.85),
        },
        '& .MuiDayPicker-slideTransition': {
            minWidth: 256,
            minHeight: 206,
            overflow: 'hidden',
        },
        '& .MuiDayPicker-weekDayLabel': {
            width: 28,
            height: 32,
        },
        '& .MuiDateRangePickerDay-day': {
            width: 28,
            height: 28,
            '&.Mui-disabled': {
                color: lighten(theme.colors.gray[800], 0.67),
            },
        },
        '& .MuiPickersDay-today:not(.Mui-selected)': {
            border: 'none',
            color: theme.colors.primary.main,
        },
    },
}));
//# sourceMappingURL=StaticDateRangePicker.styles.js.map